import React from "react";
import { Input } from '@appkit4/react-components/field';

import "../../../../src/styles/question.css";

const List = ({ data, handleOnChange, addRow, removeRow }) => {
  return (
    <div >
      {data.map((items, i1) => (
        <div key={i1} className="content">
          <div className="content-row">
            {items.map((item, i2) => (

              <Input 
              title={"Select value"}
              value={item.value}
              key={i2}
              required={true}
              onChange={(e) => handleOnChange(e,i1,i2)}
              className="autofocus marginAlignment"
              />
            ))}
          </div>
          <div>
          {data.length > 1 && i1>=1 &&(
              <span className="Appkit4-icon icon-circle-minus-fill" onClick={() => removeRow(i1)} style={{color: '#d04a02'}}></span>
            )}
            <span className="Appkit4-icon icon-circle-plus-fill" onClick={addRow} style={{color: '#d04a02'}}></span>
            
          </div>
        </div>
      ))}
    </div>
  );
};

export default List;
